import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=c349a4d0"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=c349a4d0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c349a4d0')) {
      api.createRecord('c349a4d0', component.options)
    } else {
      api.reload('c349a4d0', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=c349a4d0", function () {
      api.rerender('c349a4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/layout/menu/menu.vue"
export default component.exports